
import React, { useState, useRef,useEffect,useMemo} from 'react';
import styled from 'styled-components';
import { getHostName } from '../../utils/urlUtils';
import { CenteredContainer, LoadingIndicator } from '../dataloading';
import { useTranslation } from 'react-i18next';
import { requestUrl } from '../../requestUrl';
import { processMathString } from '../../utils/commonUtils';
import { useSnackbar } from '../../SnackbarProvider';
import CustomButton from '../../components/CustomButton';
import { Tabs, Tab, Box, Button,Select,MenuItem ,FormControl} from "@mui/material";
import { getColorDark,getColorLight,getTheme } from '../../ColorManager';
import "react-resizable/css/styles.css";
import { Excalidraw } from "@excalidraw/excalidraw";
import LoadingData from '../dataloading';
import '@wangeditor/editor/dist/css/style.css'; // 引入 css

import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import './styletheme.css';
import { exportToBlob } from "@excalidraw/excalidraw";
import { useNavigate } from 'react-router-dom';
import katex from 'katex';
import "katex/dist/katex.min.css";
import formulaModule from '@wangeditor/plugin-formula';
import { Boot, IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import { exportToCanvas } from "@excalidraw/excalidraw";
import './styletheme.css';
import PrintMenu from './PrintMenu';


// ✅ 模块外变量：是否已注册过 printMenu
let hasRegisterPrintMenu = false



const WangEditorComponentCommon = ({ pcid,pid,name,pcClassList,currentPcClassID }) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(false);
    const [loadingText,setLoadingText] = useState(false);
    const showSnackbar = useSnackbar();
    const [colorManager, setColorManager] = useState(getColorDark());
    

    const [editor, setEditor] = useState(null);
    const [html, setHtml] = useState('')
    const [pcClassnameID,setPcClassnameID] = useState(0);

    const excalidrawRef = useRef(null);
    const [excalidrawAPI, setExcalidrawAPI] = useState(null);
    const [selectedClassId,setSelectedClassId] = useState(currentPcClassID);

    const [open, setOpen] = useState(false);
    const[rolename,setRolename] = useState('user');
   

    // 用于确保 formulaModule 只注册一次
  const formulaModuleRegistered = useRef(false);


    const get_color_by_name = (name) => {

        const item = colorManager.find(item => item.container === name);
        return item.value;
      }


// 注册打印菜单（仅注册一次）
useEffect(() => {
  if (!hasRegisterPrintMenu) {
    Boot.registerMenu({
      key: 'printMenu2',
      factory: () => new PrintMenu()
    })
    hasRegisterPrintMenu = true
  }
}, [])

      const toolbarConfig = useRef({
        insertKeys: {
          index: 0, // 插入的位置，基于当前的 toolbarKeys
          keys: ['printMenu2','insertFormula'],
        },
      });
      


      useEffect(() => {
        if (!editor) return;
      
        const container = document.querySelector('.w-e-text-container');
        if (!container) return;
      
        // 创建一个复制按钮（全局固定）
        const button = document.createElement('button');
        button.innerText = '复制';
        button.className = 'copy-btn';
        button.style.cssText = `
          position: fixed;
          display: none;
          background: #409eff;
          color: white;
          border: none;
          padding: 4px 8px;
          font-size: 12px;
          border-radius: 4px;
          cursor: pointer;
          z-index: 9999;
        `;
        document.body.appendChild(button);
      
        let currentCode = null;
      
        // 监听 hover 到 code block
        container.addEventListener('mouseover', (e) => {
          const pre = e.target.closest('pre');
          const code = pre?.querySelector('code');
          if (pre && code) {
            const rect = pre.getBoundingClientRect();
            button.style.top = `${rect.top + 8}px`;
            button.style.left = `${rect.right - 60}px`;
            button.style.display = 'block';
            currentCode = code;
          }
        });
      
        // 离开区域隐藏按钮
        
      
        // 点击复制
        button.onclick = (e) => {
          e.stopPropagation();
          if (currentCode) {
            navigator.clipboard.writeText(currentCode.innerText).then(() => {
              button.innerText = '已复制';
              setTimeout(() => (button.innerText = '复制'), 1000);
            });
          }
        };
      
        return () => {
          document.body.removeChild(button);
        };
      }, [editor]);
      







      useEffect(() => {
        // 只在首次加载时注册 formulaModule
        if (typeof window !== 'undefined' && !window.__formulaModuleRegistered) {
          Boot.registerModule(formulaModule);
          window.__formulaModuleRegistered = true;  // 标记为已注册
        }
    
        let rname = localStorage.getItem("rolename");
        setRolename(rname);
    
        
      }, []);  // 依赖 editor
    
      // 在组件卸载时销毁 editor
      useEffect(() => {
        return () => {
          if (editor != null) {
            editor.destroy();
            setEditor(null);
          }
        };
      }, [editor]);


      
      useEffect(() => {
        if (open && excalidrawAPI) {
          console.log("✅ Excalidraw 组件已挂载，API 可用");
        }
      }, [open, excalidrawAPI]);




      

  // 及时销毁 editor ，重要！
  useEffect(() => {
    return () => {
      if (editor == null) return
      editor.destroy()
      setEditor(null)
    }
  }, [editor]);



  useEffect(() => {
    
    const fetchData = async () => {
        try {
            setIsLoading(true);
            setLoadingText("loading");
            const dataToSend = {
              id:pcid,
            };
            const data = await requestUrl(dataToSend, "get_studydocument_content_string",t,showSnackbar);
            if(data.status === "success"){
              console.log(data.data);
              
                setHtml(data.data);
                console.log(data.data);
                setIsLoading(false);
            }
          } catch (error) {
              console.error("获取数据时出错:", error);
          } finally {
            setIsLoading(false);
          }

          setIsLoading(false);
    };

    if(pcid > 0){
      fetchData(); 
    }
    
  }, [pcid]);
















 // **插入图片的方法**
 const insertImage = (base64String) => {
    if (!editor) return;

    const imageElem = {
        type: "image",
        src: base64String,
        style: "max-width:100%;",
        children: [{ text: "" }], // 必须添加 children，避免报错
    };
    editor.restoreSelection();//z这行代码保证了插入的图片在光标的位置
    editor.insertNode(imageElem); // **使用 insertNode() 插入图片**
};

 // **编辑器配置**
 const editorConfig1 = {
    placeholder: "请输入内容...",
    uploadImgShowBase64: true, // 允许 Base64 图片
    uploadImgServer: "", // 禁止上传到服务器
    MENU_CONF: {
        uploadImage: {
            base64LimitSize: 1500 * 2000, // 限制 Base64 图片大小（100KB）
        },
    },
    customPaste: (editor, event) => {
        const items = (event.clipboardData || window.clipboardData).items;
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                const file = items[i].getAsFile();
                const reader = new FileReader();
                reader.onload = (e) => {
                    insertImage(e.target.result); // **调用插入图片方法**
                };
                reader.readAsDataURL(file);
            }
        }
    }
};
const editorConfig = {
  placeholder: "请输入内容...",
  uploadImgShowBase64: true, // 允许 Base64 图片
  uploadImgServer: "", // 禁止上传到服务器
  MENU_CONF: {
      uploadImage: {
          base64LimitSize: 1500 * 2000, // 限制 Base64 图片大小（100KB）
      },
      hoverbarKeys: {
        formula: {
          menuKeys: ['editFormula'], // “编辑公式”菜单
        },
      },
  },
  customPaste: (editor, event) => {
      const items = (event.clipboardData || window.clipboardData).items;
      for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
              const file = items[i].getAsFile();
              const reader = new FileReader();
              reader.onload = (e) => {
                  insertImage(e.target.result); // **调用插入图片方法**
              };
              reader.readAsDataURL(file);
          }
      }
  }
};







// 获取编辑器内容
const handleSaveContent = async () => {
    const content = editor.getHtml();  // 获取 HTML 内容（包括 Base64 图片）

    try {
        setIsLoading(true);
        setLoadingText("loading");
        const dataToSend = {
            did: pcid,
            content: content,
            pid:pid,
            dname:name,
        };
        const data = await requestUrl(dataToSend, "update_studydocument_content");
        
        if(data.status === "success"){
            
            showSnackbar(t('更新完成'),'warning');
        }
      } catch (error) {
          console.error("获取数据时出错:", error);
      } finally {
        setIsLoading(false);
      }
  };



  const handleHandPaint = async () => {
    setOpen(true);
  };

  
  
  const handleClose = () => {
    setOpen(false);
  };


  const [base64Image, setBase64Image] = useState(null);

  const convertToBase64 = (blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      setBase64Image(reader.result); // 设置 Base64 数据\
      console.log(reader.result);
      insertImage(reader.result);
    };
  };


  const handlePaste = async () => {
    try {
      const clipboardItems = await navigator.clipboard.read();
      for (const item of clipboardItems) {
        for (const type of item.types) {
          if (type.startsWith("image/")) {
            const blob = await item.getType(type);
            convertToBase64(blob);
            return;
          }
        }
      }
      alert("剪贴板中没有图片！");
    } catch (error) {
      console.error("读取剪贴板图片失败:", error);
    }
  };


  const handleExport1 = async () => {
    if (!excalidrawAPI) {
      console.error("❌ Excalidraw 组件未准备好，无法导出");
      return;
    }
  
    const elements = excalidrawAPI.getSceneElements();
    if (!elements || elements.length === 0) {
      console.error("❌ 没有可导出的内容");
      return;
    }
  
    try {
      // **获取 Excalidraw 场景中的文件（包含粘贴的图片）**
      const files = excalidrawAPI.getFiles();
  
      // **使用 exportToCanvas 确保粘贴的图片被包含**
      const canvas = await exportToCanvas({
        elements,
        appState: {
          exportWithDarkMode: false,
        },
        files, // 关键：必须传入 files 才能导出粘贴的图片
        getDimensions: () => {
          return { width: 800, height: 600 }; // 可调整尺寸
        },
      });
  
      // **将 Canvas 转换为 Blob**
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("❌ Canvas 转 Blob 失败");
          return;
        }
  
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => {
          console.log("✅ Base64 image:", reader.result);
          setBase64Image(reader.result);
          insertImage(reader.result); // 插入到 wangeditor
          setOpen(false);
        };
        reader.onerror = (error) => {
          console.error("❌ 读取 Blob 失败:", error);
        };
      }, "image/png");
    } catch (error) {
      console.error("❌ 导出图片出错:", error);
    }
  };
  
  const getCanvasBounds = (elements) => {
    if (!elements || elements.length === 0) {
      return { minX: 0, minY: 0, width: 800, height: 600 }; // 默认尺寸
    }
  
    // 计算所有元素的边界
    let minX = Infinity,
      minY = Infinity,
      maxX = -Infinity,
      maxY = -Infinity;
  
    elements.forEach((el) => {
      if (el.x < minX) minX = el.x;
      if (el.y < minY) minY = el.y;
      if (el.x + el.width > maxX) maxX = el.x + el.width;
      if (el.y + el.height > maxY) maxY = el.y + el.height;
    });
  
    // 计算最终宽高
    const width = maxX - minX+50;
    const height = maxY - minY+50;
  
    return { minX, minY, width, height };
  };
  

  const handleExport = async () => {
    if (!excalidrawAPI) {
      console.error("❌ Excalidraw 组件未准备好，无法导出");
      return;
    }
  
    const elements = excalidrawAPI.getSceneElements();
    if (!elements || elements.length === 0) {
      console.error("❌ 没有可导出的内容");
      return;
    }
  
    try {
      // **获取 Excalidraw 场景中的文件（确保包含粘贴的图片）**
      const files = excalidrawAPI.getFiles();
  
      // **计算绘制内容的实际范围**
      const { minX, minY, width, height } = getCanvasBounds(elements);
  
      // **使用 exportToCanvas 确保粘贴的图片和所有绘制内容都包含**
      const canvas = await exportToCanvas({
        elements,
        appState: {
          exportWithDarkMode: false,
        },
        files,
        getDimensions: () => {
          return { width, height }; // 根据实际内容大小动态调整
        },
      });
  
      // **将 Canvas 转换为 Blob**
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("❌ Canvas 转 Blob 失败");
          return;
        }
  
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => {
          console.log("✅ Base64 image:", reader.result);
          setBase64Image(reader.result);
          insertImage(reader.result); // 插入到 wangeditor
          setOpen(false);
        };
        reader.onerror = (error) => {
          console.error("❌ 读取 Blob 失败:", error);
        };
      }, "image/png");
    } catch (error) {
      console.error("❌ 导出图片出错:", error);
    }
  };
  


  //保存到模板
  const handleSavePCTemplate = async () => {
    const content = editor.getHtml();  // 获取 HTML 内容（包括 Base64 图片）
    
    console.log(content);

    try {
        setIsLoading(true);
        setLoadingText("loading");
        const dataToSend = {
         
          content:html,
        };
        const data = await requestUrl(dataToSend, "update_pc_template");
        
        if(data.status === "success"){
           
            showSnackbar(t('更新完成'),'warning');
        }
      } catch (error) {
          console.error("获取数据时出错:", error);
      } finally {
        setIsLoading(false);
      }
  }


  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleMaxScreen = () => {
      setIsFullScreen(!isFullScreen);
  };

  
    return (
        <>
        <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
          <Toolbar
            editor={editor}
            defaultConfig={toolbarConfig.current}
            mode="default"
            style={{ borderBottom: '1px solid #ccc' }}
          />
          <Editor
            defaultConfig={editorConfig}
            value={html}
            onChange={(editor) => setHtml(editor.getHtml())}
            onCreated={setEditor}
            mode="default"
            style={{ height: '75vh', overflowY: 'hidden' }}
        />
      
        </div>

        <div
            style={{
                display: "flex",
                justifyContent: "flex-end", // 靠右对齐
                gap: "20px", // 按钮之间的间距
                marginRight: "20px", // 距离右侧边缘 20px
                
            }}
            >
          {rolename === "admin" && (
            <CustomButton onClick={handleSavePCTemplate} sx={{ marginTop: "10px" }} width="170px">
                {t("保存到题库模板")}
            </CustomButton>
          )}


            <CustomButton onClick={handleSaveContent} sx={{ marginTop: "10px" }} width="170px">
                {t("保存内容")}
            </CustomButton>

            <CustomButton onClick={handleHandPaint} sx={{ marginTop: "10px" }} width="170px">
                {t("绘板")}
            </CustomButton>
            </div>


            {open && (
    <Box
        sx={{
            position: "fixed",
            top: isFullScreen ? 0 : "50%",
            left: isFullScreen ? 0 : "50%",
            transform: isFullScreen ? "none" : "translate(-50%, -50%)",
            width: isFullScreen ? "100vw" : "90vw",
            height: isFullScreen ? "100vh" : "90vh",
            backgroundColor: "white",
            boxShadow: 24,
            padding: 2,
            borderRadius: isFullScreen ? 0 : "8px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between", // 让 Excalidraw 和按钮区域分开
            alignItems: "center",
            zIndex: 9999,
            overflow: "hidden",
        }}
    >
        {/* Excalidraw 区域 */}
        <Box
            sx={{
                flex: 1,
                width: "100%",
                height: isFullScreen ? "100%" : "calc(100% - 60px)", // 非全屏时留出按钮空间
            }}
        >
            <Excalidraw style={{height:'100%'}} excalidrawAPI={(api) => setExcalidrawAPI(api)} />
        </Box>

        {/* 按钮区域 */}
        <Box
            sx={{
                width: "100%",
                
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                backgroundColor: "rgba(255, 255, 255, 0.9)", // 透明背景，防止遮挡
                padding: "10px",
            }}
        >
            <CustomButton onClick={handleClose}>{t("close")}</CustomButton>
            <CustomButton onClick={handleExport}>{t("add image")}</CustomButton>
            <CustomButton onClick={handleMaxScreen}>
                {isFullScreen ? t("退出全屏") : t("全屏显示")}
            </CustomButton>
        </Box>
    </Box>
)}

        {isLoading && (
            <LoadingData text={t(loadingText)}/>
        )}

      </>
    );
};
  

export default WangEditorComponentCommon;